







































































































































import Vue from "vue";
import TravelModesColors from "@/constants/travelModesColors";
import LabelHorizontal from "@/components/travel_planning/LabelHorizontal.vue";
import LabelVertical from "@/components/travel_planning/LabelVertical.vue";
export default Vue.extend({
  data() {
    return {
      stackedChartSettings: {
        stack: {
          xxx: [
            "car",
            "carpool",
            "public_bus",
            "school_bus",
            "taxi",
            "train",
            "walking",
            "bicycling",
          ],
        },

        colors: ["red"],
      },
      stackedChartPercentsSettings: {
        stack: {
          xxf: [
            "car",
            "carpool",
            "public_bus",
            "school_bus",
            "taxi",
            "train",
            "walking",
            "bicycling",
          ],
        },
        // yAxisType: "value",
        colors: ["red"],
      },
      stackedChart: {
        columns: [
          "distance_group",
          "car",
          "carpool",
          "Auxh",
          "school_bus",
          "taxi",
          "train",
          "walking",
          "bicycling",
        ],
        rows: [
          { date: "Year 1", bus: 5, car: 32, train: 12, walk: 7, bike: 44 },
          { date: "Year 2", bus: 14, car: 35, train: 12, walk: 29, bike: 10 },
          { date: "Year 3", bus: 17, car: 41, train: 12, walk: 19, bike: 11 },
          { date: "Year 4", bus: 12, car: 20, train: 12, walk: 38, bike: 18 },
          { date: "Year 5", bus: 2, car: 12, train: 32, walk: 20, bike: 34 },
          { date: "Year 6", bus: 7, car: 27, train: 12, walk: 34, bike: 20 },
        ],
        colors: ["green"],
      },
      colors: { ...TravelModesColors },
      radiusChartSettings: {
        label: {
          normal: {
            show: false,
            position: "center",
            // formatter: function (params) {
            //   params.name = 'dd';
            //   params.data.name = 'ouch';
            //   console.log(params);
            //   return params.name;
            //             }
          },

        },
        // roseType: "radius",
      },
    };
  },
  components: {
    LabelHorizontal,
    LabelVertical,
  },
  props: ["stats"],
  computed: {
    chartData: function () {
      if (this.stats) {
        return {
          columns: [
            "distance_group",
            "car",
            "carpool",
            "public_bus",
            "school_bus",
            "taxi",
            "train",
            "walking",
            "bicycling",
          ],
          rows: this.stats.groupsByDistanceGroupCount,
        };
      } else {
        return null;
      }
    },
    chartDataPerc: function () {
      if (this.stats) {
        return {
          columns: [
            "distance_group",
            "car",
            "carpool",
            "public_bus",
            "school_bus",
            "taxi",
            "train",
            "walking",
            "bicycling",
          ],
          rows: this.stats.groupsByDistanceCountFormattedPercents,
        };
      } else {
        return null;
      }
    },
    habitsData: function () {
      if (this.stats) {
        return {
          columns: [
            "type",
            "car",
            "carpool",
            "public_bus",
            "school_bus",
            "taxi",
            "train",
            "walking",
            "bicycling",
          ],
          rows: this.stats.habbitsBySchoolYear,
        };
      } else {
        return null;
      }
    },
    travelModesData: function () {
      if (this.stats) {
        return {
          columns: ["type", "journeys"],
          rows: this.stats.groupsByTravelModeCount,
        };
      } else {
        return null;
      }
    },
    travelModesDataColors: function () {
      if (this.stats.groupsByTravelModeCount) {
        const colors = [];
        this.stats.groupsByTravelModeCount.forEach((element) => {
          colors.push(this.colors[element.type.toLowerCase()]);
        });
        return colors;
      } else {
        return [];
      }
    },
    legendOptions: function(){
      return {
        formatter: function (params) {
          return params.replace('_', ' ');
      }
      }
    },
    tooltipOptions: function(){
      return {
        formatter: function (params) {
          return params.marker + ' ' + params.name.replace('_', ' ') + ': '+ (typeof params.data === 'object' ? params.data.value + ' journeys': params.data);
        },
        textStyle: {
          fontSize: 20
        }
      }
    },
    tooltipPercOptions: function(){
      return {
        formatter: function (params) {
          return params.marker + ' ' + params.name.replace('_', ' ') + ': '+ params.data + '%';
        },
        textStyle: {
          fontSize: 20
        }
      }
    }
  },
});
